export default __webpack_public_path__ + "static/media/developer-blue.13756e48.svg";